import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    width: 80vw;
    align-items: initial;
    justify-content: space-between;
`;

export const WelcomeContainer = styled.div`
    min-width: 150px;
`;

export const WelcomeText = styled.p`
    font-family: "Lexend Deca";
    font-size: 14px;
    color: #5D9040;
`;

export const LogoImage = styled.img`
    margin-top: 35px;
`;
export const LogContainer = styled.div`
    display: flex;
    gap: 20px;
    height: 20px;
`;
